var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-center-page"},[_c('EsHeaderView'),_c('div',{staticClass:"container-box"},[_c('div',{staticClass:"page-main app-container"},[_c('navBar'),_c('div',{staticClass:"set-container"},[_c('router-view')],1)],1)]),_c('EsFooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }